// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_uo-8";
export var editMode = "_uo-3";
export var headerRow = "_uo-a";
export var headerTitle = "_uo-b";
export var product = "_uo-1";
export var productDetails = "_uo-5";
export var productDivider = "_uo-7";
export var productImage = "_uo-2";
export var productInfo = "_uo-4";
export var productTitle = "_uo-6";
export var strikethrough = "_uo-9";
export var upsellProductsCard = "_uo-0";